<template>
  <div>
    <Header2 />
    <el-carousel
      height="400px"
      :indicator-position="homeMessage ? 'none' : ''"
      :autoplay="true"
      :arrow="homeMessage ? 'always' : 'never'"
      ref="carousel"
      @click.native="linkTo"
    >
      <el-carousel-item v-for="(item, index) in banner" :key="index">
        <Banner
          :title="item.title"
          :subtitle="item.subtitle"
          :des="item.des"
          :extraTitle="item.extraTitle"
          :backgroundImage="item.backgroundImage"
        />
      </el-carousel-item>
    </el-carousel>
    <PublicNotice />
    <DataStatistic v-if="normal" />
    <Progress />
    <FinancProductEnter />
    <!-- <div class="capture-width-layout">
            <TitleComponent text="标签展示" />
            <LabelGroup />
        </div>-->
    <div class="capture-width-layout">
      <TitleComponent text="产品展示" />
      <ProductList
        v-if="productList.length"
        :productList="productList"
        :productItemNumber="5"
        :hasPagination="false"
        @onProductItem="onProductItem"
      />
      <div v-else class="no-data-box">
        <noData />
      </div>
    </div>
    <div class="show-more-block" v-if="productList.length">
      <el-button class="show-more-block__btn" @click="handleMore">查看更多</el-button>
    </div>
    <OrderTips />
    <!-- <BankCarousel /> -->
  </div>
</template>

<script>
import Header2 from '@/components/Header/index'
import TitleComponent from '@/components/TitleComponent'
import FinancProductEnter from './components/FinancProductEnter'
import ProductList from '@/components/ProductList'
import Banner from '@/components/Banner'
import noData from '@/components/noData'
import Progress from './components/Progress'
import PublicNotice from './components/PublicNotice'
import OrderTips from './components/OrderTips'
import DataStatistic from '@/components/dataStatistic'
// import LabelGroup from './components/LabelGroup'
// import BankCarousel from '@/components/BankCarousel'
import { getAndSaveDistrictIdFromUrl } from '@/utils/common.js'

import { mapState } from 'vuex'
export default {
  components: {
    Header2,
    Progress,
    FinancProductEnter,
    ProductList,
    TitleComponent,
    Banner,
    noData,
    PublicNotice,
    OrderTips,
    DataStatistic,
    // LabelGroup
    // BankCarousel
  },
  data() {
    return {
      notifyContent: '',
      bannerSpecial: [
        {},
        {
          title: '企业跨境金融服务',
          subtitle: '支持“一带一路”',
          des: '支持企业“走出去“发展，助推企业“走出去“发展',
          backgroundImage: require('../../assets/images/backwithsomething-new.png'),
          url: '/road',
        },
        {
          title: '银行线上办理知识产权质押登记试点',
          subtitle: '国家知识产权局 国家金融监督管理总局',
          des: '强化知产与金融深度融合，助力科创企业高质量发展',
          backgroundImage: require('../../assets/images/knowleage/knowleage-banner-new.png'),
          url: '/knowledge',
        },
      ],
      banner: [
        {
          title: '浙江省金融综合服务平台',
          extraTitle: '',
          subtitle: '',
          des: '全国融资信用服务平台浙江站',
          backgroundImage: require('../../assets/images/banner-believe-new.png'),
          url: '/',
        },
        {},
        {
          title: '企业跨境金融服务',
          subtitle: '支持“一带一路”',
          des: '支持企业“走出去“发展，助推企业“走出去“发展',
          backgroundImage: require('../../assets/images/backwithsomething-new.png'),
          url: '/road',
        },
        {
          title: '银行线上办理知识产权质押登记试点',
          subtitle: '国家知识产权局 国家金融监督管理总局',
          des: '强化知产与金融深度融合，助力科创企业高质量发展',
          backgroundImage: require('../../assets/images/knowleage/knowleage-banner-new.png'),
          url: '/knowledge',
        },
      ],
      normal: true,
    }
  },
  async mounted() {
    const assess = sessionStorage.getItem('productName')
    const userFrom = sessionStorage.getItem('userFrom')
    if (assess === '知识产权' || userFrom === '浙企融') {
      this.normal = false
      this.banner = this.bannerSpecial
    }
    if (this.$appTarget === 'jxt') {
      await getAndSaveDistrictIdFromUrl()
    }
    this.getHomeProductList()
    this.$root.$on('area-change', this.getHomeProductList)
  },
  beforeDestroy() {
    this.$root.$off('area-change', this.getHomeProductList)
  },
  computed: {
    ...mapState('product', {
      productList: (state) => state.productList,
    }),
    ...mapState({
      homeMessage: ({ message }) => message.homeMessage,
    }),
  },
  methods: {
    linkTo(data) {
      let index = this.$refs.carousel.activeIndex
      if (index && this.banner[index] && this.banner[index].url && this.banner[index].url !== '/') {
        // window.location.href = this.banner[index].url
        this.$router.push({
          path: this.banner[index].url,
        })
      }
    },

    getHomeProductList() {
      const loading = this.$loading({
        target: '#productList',
        fullscreen: false,
      })
      this.$store.dispatch('product/getProductPagingList', { pageNo: 1, pageSize: 5 }).then(() => {
        loading.close()
      })
    },
    onProductItem(id) {
      this.$router.push({
        path: '/product-detail',
        query: { id },
      })
    },
    handleMore() {
      this.$router.push({
        name: 'product',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.capture-width-layout {
  @include common-layout;
}

.show-more-block {
  padding: 30px 0 50px;

  &__btn {
    width: 120px;
    height: 40px;
    font-size: 16px;
    text-align: center;
    color: $main-color;
    border-color: $main-color;
    border-radius: 8px;
    background-color: transparent;

    &:hover {
      border-color: $main-color;
    }
  }
}
.no-data-box {
  padding: 100px 0;
}
.notify {
  margin-top: 10px;
}
/deep/ .el-carousel__arrow {
  background-color: rgba(31, 45, 61, 0);
  i {
    font-size: 16px;
  }
}
</style>
